import { css } from "@emotion/react";
import type { ProductDetailPageDataShared } from "@swo/storefront";
import React, { useMemo } from "react";
import { ContentContainer } from "../../components/_shared-components/arrangement/Container";
import { CSS_COLORS, CSS_SPACER_SIZES } from "../../styles/styles-css-variables";
import { PDPHeadlineOnBackground } from "./pdp-headline";
import { CardsCarousel2 } from "./PDP_IconsAndTexts/CardsCarousel/CardsCarousel2";
import { ProReviewCard } from "./ProReviewCard";
import type { ReviewTranslations } from "./reviewTranslations";
import { T } from "../../components/T";

type ProReviews = ProductDetailPageDataShared["proReviews"];
type ProReview = ProReviews[number];

type ProReviewsProps = {
  reviews: ProReviews;
  t: ReviewTranslations;
};

export const ProReviews: React.FC<ProReviewsProps> = ({ reviews, t }) => {
  const headline = t("proReviews.headline");
  const mentionedproductsHeadline = t("proReviews.mentionedProducts");

  const Component = useMemo(() => {
    return (props: { item: ProReview; isActive?: boolean; ref?: any; minHeight: number }) => {
      return (
        <ProReviewCard
          {...props}
          headline={mentionedproductsHeadline}
          isActive={props.isActive}
          t={t}
          ref={props.ref}
          minHeight={props.minHeight}
        />
      );
    };
  }, [mentionedproductsHeadline]);

  return (
    <div
      css={css`
        background-color: ${CSS_COLORS.GreenDark};
        color: ${CSS_COLORS.White};
        padding-top: ${CSS_SPACER_SIZES.md};
        padding-bottom: ${CSS_SPACER_SIZES.md};

        overflow-x: hidden;
      `}
    >
      <ContentContainer>
        <PDPHeadlineOnBackground color={"inherit"}>
          <T>{headline}</T>
        </PDPHeadlineOnBackground>

        <CardsCarousel2 items={reviews} Component={Component} getKey={_ => _.sysId} theme={"dark-background"} />
      </ContentContainer>
    </div>
  );
};
